/**
 * Product page: autoplay only visible gallery deferred-media (not all slides).
 */
(function () {
  'use strict';

  function pauseVideo(video) {
    if (!video) return;
    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {
      /* no-op */
    }
  }

  function getActiveGallerySlide(mediaGallery) {
    if (!mediaGallery) return null;
    const slider = mediaGallery.querySelector('[id^="Slider-Gallery-"]');
    if (!slider) return null;
    return slider.querySelector('li.is-active') || slider.querySelector('li:not(.hidden)');
  }

  function getDeferredMediaFromSlide(slide) {
    if (!slide) return null;
    return slide.querySelector('deferred-media');
  }

  function setupVideoAutoplay(wrapper) {
    const posterButton = wrapper.querySelector('[id^="Deferred-Poster-"]');
    if (posterButton) posterButton.click();

    setTimeout(() => {
      const video = wrapper.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');

      video.play().catch(() => {});

      wrapper.addEventListener('click', () => {
        video.play().catch(() => {});
      });
    }, 150);
  }

  function pauseHiddenGalleryVideos(mediaGallery) {
    if (!mediaGallery) return;
    const activeSlide = getActiveGallerySlide(mediaGallery);
    mediaGallery.querySelectorAll('[id^="Slider-Gallery-"] li').forEach((slide) => {
      if (slide === activeSlide) return;
      slide.querySelectorAll('video').forEach(pauseVideo);
    });
  }

  function loadVisibleDeferredMedia() {
    const mediaGallery = document.querySelector('media-gallery');
    const activeSlide = getActiveGallerySlide(mediaGallery);
    const wrapper = getDeferredMediaFromSlide(activeSlide);

    if (wrapper) {
      setupVideoAutoplay(wrapper);
    }

    pauseHiddenGalleryVideos(mediaGallery);
  }

  function init() {
    loadVisibleDeferredMedia();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        setTimeout(loadVisibleDeferredMedia, 200);
      });
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
        setTimeout(loadVisibleDeferredMedia, 300);
      });
    }

    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery) {
      mediaGallery.querySelectorAll('slider-component').forEach((slider) => {
        slider.addEventListener('slideChanged', () => {
          setTimeout(loadVisibleDeferredMedia, 200);
        });
      });
    }
  }

  function initGokwikSticky() {
    const stickyContainer = document.getElementById('gokwik-sticky-container');
    if (!stickyContainer) return;

    function initSticky() {
      const originalBtn = document.getElementById('gokwik-buy-now');
      if (!originalBtn) return;

      const clone = originalBtn.cloneNode(true);
      clone.style.display = 'block';
      clone.id = 'gokwik-buy-now-sticky';

      stickyContainer.innerHTML = '';
      stickyContainer.appendChild(clone);

      function checkVisibility() {
        const rect = originalBtn.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

        if (!isVisible) {
          stickyContainer.style.display = 'block';
          document.body.classList.add('has-sticky-btn');
        } else {
          stickyContainer.style.display = 'none';
          document.body.classList.remove('has-sticky-btn');
        }
      }

      window.addEventListener('scroll', checkVisibility, { passive: true });
      window.addEventListener('resize', checkVisibility, { passive: true });
      checkVisibility();
    }

    if (window.gokwikLoaded) {
      setTimeout(initSticky, 800);
    } else {
      window.addEventListener('gokwikLoaded', () => {
        setTimeout(initSticky, 800);
      });
    }
  }

  function initAll() {
    init();
    initGokwikSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
